import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'

import { AdminPage } from '@/admin/AdminPage'
import { BotSimulationPage } from '@/admin/BotSimulationPage'
import { LiveReplyPage } from '@/admin/LiveReplyPage'
import { AuthProvider } from '@/auth/AuthContext'
import { LoginPage } from '@/auth/LoginPage'
import { RequireAuth } from '@/auth/RequireAuth'

export function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<Navigate to="/admin/live-reply" replace />} />
          <Route
            path="/admin"
            element={
              <RequireAuth>
                <AdminPage />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/bot-simulations"
            element={
              <RequireAuth>
                <BotSimulationPage />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/live-reply"
            element={
              <RequireAuth>
                <LiveReplyPage />
              </RequireAuth>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  )
}
